import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'tab-panel',
  templateUrl: './tab-panel.component.html',
  styleUrls: ['./tab-panel.component.scss']
})
export class TabPanelComponent {
    @Input() title = '';
    @ViewChild(TemplateRef, { static: true }) tplRef!: TemplateRef<unknown>;
}
